import React from "react";
import { Select, ConfigProvider } from "antd";

/**
 * Custom SelectField styled component
 */
const SelectField = ({
  hoverBorder = false,
  size = "large",
  style = {},
  className = "",
  children,
  ...rest
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            borderColor: "transparent",
            borderRadius: 4,
            controlHeightLG: 40,
            optionSelectedBg: "e6f4ff",
            optionActiveBg: "#f0f5ff",
            colorBgContainer: "rgba(0,0,0,0.04)",
            colorBorder: "transparent",           // ensures no default border
            activeShadow: "none",                 // removes focus ring
            controlOutline: "none",      
          },
        },
      }}
    >
      <Select
        size={size}
        style={{ width: "100%", ...style }}
        className={`${hoverBorder ? "custom-input-hover" : ""} ${className}`}
        {...rest}
      >
        {children}
      </Select>
    </ConfigProvider>
  );
};

export default SelectField;
